import { render, staticRenderFns } from "./ImagePickerPagination.vue?vue&type=template&id=2434415c&scoped=true&"
import script from "./ImagePickerPagination.vue?vue&type=script&lang=js&"
export * from "./ImagePickerPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434415c",
  null
  
)

export default component.exports